module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


//////////////////
// WEBPACK FOOTER
// external {"root":["rxjs"],"commonjs":"rxjs","commonjs2":"rxjs","amd":"rxjs"}
// module id = 42
// module chunks = 0